<span class="visible-xs" data-breakpoint="xs"></span>
<span class="visible-sm" data-breakpoint="sm"></span>
<span class="visible-md" data-breakpoint="md"></span>
<span class="visible-lg" data-breakpoint="lg"></span>
